module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Special Collection Archive")]), _vm._v(" "), _vm._l((_vm.collections), function(collection) {
    return [_c('div', {
      staticClass: "collection-container"
    }, [_c('media-container', {
      key: collection.articlesData.ids.pii,
      attrs: {
        "collections-header": true,
        "issue": collection.articlesData,
        "figures": collection.articlesData.files.figures
      }
    }), _vm._v(" "), _c('h2', [_c('router-link', {
      attrs: {
        "to": {
          name: 'collectionDetail',
          params: {
            id: collection.id
          }
        }
      }
    }, [_vm._v("Special Collection on Some Topic")])], 1), _vm._v(" "), _c('div', {
      staticClass: "types"
    }, [_vm._v(_vm._s(collection.articlesTypes.length) + " Papers inlcuding: " + _vm._s(collection.articlesTypes.join(', ')))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(collection.description))]), _vm._v(" "), _c('div', {
      staticClass: "text-center hidden-md-up"
    }, [_c('b-button', {
      staticClass: "button-secondary my-2 my-sm-0",
      attrs: {
        "variant": "link",
        "to": {
          name: 'collectionDetail',
          params: {
            id: collection.id
          }
        }
      }
    }, [_vm._v("\n          View Collection\n        ")])], 1)], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-412d6f14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/CollectionsPage.vue
// module id = 1424
// module chunks = 1